import {
  AccessKeyContext,
  AccessKeyRequest,
  AuthzApi as AuthZApiInternal,
} from '@portal/pkg-api/gen/authz'
import { RestApiConfiguration } from '@portal/pkg-api/config'
import { data } from '@portal/pkg-api/shared'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

export const AuthZApi = new AuthZApiInternal(RestApiConfiguration)

const prefix = 'admin.oauth'

export const AuthZQueries = {
  accessKeys: () => ({
    queryKey: [`${prefix}.accessKeys`],
    queryFn: () => data(AuthZApi.getAccessKeys()),
  }),
  clients: () => ({
    queryKey: [`${prefix}.clients`],
    queryFn: () => data(AuthZApi.getClients()),
  }),
}

export function useAccessKeys() {
  return useQuery(AuthZQueries.accessKeys())
}

export function useClients() {
  return useQuery(AuthZQueries.clients())
}

export function useCreateAccessKey() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (accessKey: AccessKeyRequest) => data(AuthZApi.createAccessKey(accessKey)),
    onSuccess: () => {
      void queryClient.invalidateQueries(AuthZQueries.accessKeys())
    },
  })
}

export function useEnableAccessKey() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (accessKey: Partial<AccessKeyContext>) =>
      data(AuthZApi.enableAccessKey(accessKey.id!, accessKey.enabled!)),
    onSuccess: () => {
      void queryClient.invalidateQueries(AuthZQueries.accessKeys())
    },
  })
}

export function useDeleteAccessKey() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => data(AuthZApi.deleteAccessKey(id)),
    onSuccess: () => {
      void queryClient.invalidateQueries(AuthZQueries.accessKeys())
    },
  })
}
